import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faReceipt } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";
import { Link, useNavigate, useParams } from "react-router-dom";
import Title from "../../components/title";

function ShowhealthData(props) {
  const columns = [
    { name: "إسم المرض", key: "disease_name" },
    { name: " نوع المرض", key: "disease_type" },
    { name: "نوع العلاج", key: "treatment_type" },
    { name: "تكلفة العلاج", key: "treatment_cost" },
    { name: " خطورة المرض", key: "disease_degree" },
    { name: " ملاحظات", key: "notes" },
    { name: "", key: "actions" },
  ];
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  // const getHumanCases = async () => {
  //     try {
  //         const res = await API.post(`/healthdata/${id}`);
  //         const data = await res;
  //         if (data.status === 200) {
  //             setRows(data.data);
  //             setLoading(false);
  //         }
  //     } catch (error) {
  //         console.error(error);
  //         setError(error.response.data.errors);
  //     }
  // };
  // useEffect(() => {
  //     getHumanCases();
  // }, []);
  const dropdownOptions = [{ label: "تعديل", route: "/edithealthData/:id" }];

  const handleDownload = (selectedRows) => {
    const selectedData = rows.filter((row) => selectedRows.includes(row.id));
    if (selectedData.length === 0) {
      alert("Please select at least one row.");
      return;
    }

    const csvHeader = columns
      .filter((col) => col.key !== "actions")
      .map((col) => col.name)
      .join(",");

    const csvRows = selectedData.map((row) =>
      columns
        .filter((col) => col.key !== "actions")
        .map((col) => `"${row[col.key] || ""}"`)
        .join(",")
    );

    const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

    const bom = "\uFEFF";
    const finalContent = bom + csvContent;

    const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "selected_rows_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // useEffect(() => {
  //     getHumanCases();
  // }, []);

  return (
    <>
      <div className=" employpaper">
        <Title
          title="البيانات الصحية"
          style={{ width: "unset" }}
          classname="rmtit"
          icon={<FontAwesomeIcon icon={faReceipt} />}
        />

        <Link
          to={`/healthData/${id}`}
          className="archive-report archive-report2 no-print">
          <span className="add-row-ta archiveAdd ">
            {" "}
            <FontAwesomeIcon icon={faPlus} /> اضافة مرض جديد
          </span>
        </Link>
        <TableComponent
          apiUrl={`/humancasedetails/showhealthdata/${id}`}
          columns={columns}
          // title="البيانات الصحية"
          // titleIcon={<FontAwesomeIcon icon={faReceipt} />}
          dropdownOptions={dropdownOptions}
          searchDate={false}
        />
      </div>
    </>
  );
}

export default ShowhealthData;
